import type { RouteRecordRaw } from 'vue-router';
import { REPORT_ROUTE_NAME } from '@/consts';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const reportRoutes: RouteRecordRaw = {
  path: '/report',
  component: () => import('@/layouts/main.vue'),
  meta: { requireAuth: true, requireStoreId: true, i18n },
  children: [
    {
      name: REPORT_ROUTE_NAME.REPORT,
      path: '',
      component: () => import('./Report.vue'),
    },
  ],
};
